export default __webpack_public_path__ + "static/media/meta.e1744ecc.svg";